"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_image_file_resizer_1 = require("react-image-file-resizer");
var piexif = require("piexifjs");
var imageDimensionLimit = 4200;
var imageSizeLimit = (10485760 / 4) * 3;
var getBase64Size = function (base64) {
    var padding = base64.length
        ? getBase64Padding(base64)
        : 0;
    return (Math.ceil(base64.length / 4) * 3) - padding;
};
var getBase64Padding = function (base64) {
    return endsWith(base64, '==')
        ? 2
        : 1;
};
var endsWith = function (str, end) {
    var charsFromEnd = end.length;
    var extractedEnd = str.slice(-charsFromEnd);
    return extractedEnd === end;
};
var imageResizeHelper = {
    checkAndResize: function (file, fileContents) {
        var _this = this;
        return new Promise(function (resolve) {
            var imageSize = file.size;
            var imageSizeTooLarge = imageSize > imageSizeLimit;
            var img = new Image();
            img.src = fileContents;
            img.onload = function () {
                if (imageSizeTooLarge) {
                    _this.resize(file, 90, fileContents)
                        .then(function (result) {
                        resolve(result);
                    })
                        .catch(function (reason) {
                        _this.resize(file, 80, fileContents)
                            .then(function (result) {
                            resolve(result);
                        });
                    });
                }
                else {
                    resolve(fileContents);
                }
            };
        });
    },
    resize: function (file, quality, fileContents) {
        console.log("Resize quality: " + quality);
        return new Promise(function (resolve, reject) {
            react_image_file_resizer_1.default.imageFileResizer(file, imageDimensionLimit, imageDimensionLimit, 'JPEG', quality, 0, function (uri) {
                var size = 0;
                var contentWithExif = "";
                if (file.type === "image/jpeg") {
                    var exifObject = piexif.load(fileContents);
                    var exifString = piexif.dump(exifObject);
                    contentWithExif = piexif.insert(exifString, uri);
                    size = getBase64Size(contentWithExif);
                }
                else {
                    size = getBase64Size(uri);
                }
                if (size > imageSizeLimit) {
                    reject("Size (" + size + ") too large");
                }
                else {
                    if (file.type === "image/jpeg") {
                        resolve(contentWithExif);
                    }
                    else {
                        resolve(uri);
                    }
                }
            }, 'base64');
        });
    }
};
exports.default = imageResizeHelper;
//# sourceMappingURL=imageResizeHelper.js.map